import React from 'react';
import {
  PieChart, Pie, Cell, RadialBarChart, RadialBar, ResponsiveContainer, Tooltip
} from 'recharts';

// Hook para detectar si es móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

/**
 * Gauges and pie charts section
 */
export const GaugesSection = ({ latestData }) => {
  const isMobile = useIsMobile();
  const chartHeight = isMobile ? 160 : 200;
  const pieInnerRadius = isMobile ? 40 : 50;
  const pieOuterRadius = isMobile ? 65 : 80;

  // Pie chart data
  const pieDataDO = [
    { name: 'DO Sensor 1', value: latestData?.do1_mgL || 0, color: '#06b6d4' },
    { name: 'DO Sensor 2', value: latestData?.do2_mgL || 0, color: '#8b5cf6' },
  ];

  const pieDataSat = [
    { name: 'Saturación 1', value: latestData?.sat1_pct || 0, color: '#10b981' },
    { name: 'Saturación 2', value: latestData?.sat2_pct || 0, color: '#f97316' },
  ];

  // Radial data for gauges
  const radialDataDO1 = [
    { name: 'DO1', value: latestData?.do1_mgL || 0, fill: '#06b6d4' }
  ];

  const radialDataDO2 = [
    { name: 'DO2', value: latestData?.do2_mgL || 0, fill: '#8b5cf6' }
  ];

  return (
    <>
      <div className="section-title">
        <span className="section-icon">🎯</span>
        Distribución y Promedios
      </div>
      <div className="stats-grid fade-in stagger-4">
        {/* DO Pie Chart */}
        <div className="pie-card">
          <div className="pie-title">💧 Distribución Oxígeno Disuelto</div>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <PieChart>
              <Pie
                data={pieDataDO}
                cx="50%"
                cy="50%"
                innerRadius={pieInnerRadius}
                outerRadius={pieOuterRadius}
                paddingAngle={5}
                dataKey="value"
              >
                {pieDataDO.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="pie-legend">
            {pieDataDO.map((item, i) => (
              <div key={i} className="legend-item">
                <div className="legend-dot" style={{ background: item.color }}></div>
                <span>{isMobile ? `DO${i+1}` : item.name}: {item.value.toFixed(2)} mg/L</span>
              </div>
            ))}
          </div>
        </div>

        {/* Saturation Pie Chart */}
        <div className="pie-card">
          <div className="pie-title">📊 Distribución Saturación</div>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <PieChart>
              <Pie
                data={pieDataSat}
                cx="50%"
                cy="50%"
                innerRadius={pieInnerRadius}
                outerRadius={pieOuterRadius}
                paddingAngle={5}
                dataKey="value"
              >
                {pieDataSat.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="pie-legend">
            {pieDataSat.map((item, i) => (
              <div key={i} className="legend-item">
                <div className="legend-dot" style={{ background: item.color }}></div>
                <span>{isMobile ? `Sat${i+1}` : item.name}: {item.value.toFixed(1)}%</span>
              </div>
            ))}
          </div>
        </div>

        {/* DO1 Gauge */}
        <div className="gauge-card">
          <div className="gauge-title">🎯 Gauge DO Sensor 1</div>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="100%"
              barSize={isMobile ? 12 : 15}
              data={radialDataDO1}
              startAngle={180}
              endAngle={0}
            >
              <RadialBar
                background={{ fill: 'rgba(255,255,255,0.1)' }}
                dataKey="value"
                cornerRadius={10}
              />
            </RadialBarChart>
          </ResponsiveContainer>
          <div className="gauge-value" style={{ color: '#06b6d4' }}>
            {latestData?.do1_mgL?.toFixed(2)} mg/L
          </div>
        </div>

        {/* DO2 Gauge */}
        <div className="gauge-card">
          <div className="gauge-title">🎯 Gauge DO Sensor 2</div>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="100%"
              barSize={isMobile ? 12 : 15}
              data={radialDataDO2}
              startAngle={180}
              endAngle={0}
            >
              <RadialBar
                background={{ fill: 'rgba(255,255,255,0.1)' }}
                dataKey="value"
                cornerRadius={10}
              />
            </RadialBarChart>
          </ResponsiveContainer>
          <div className="gauge-value" style={{ color: '#8b5cf6' }}>
            {latestData?.do2_mgL?.toFixed(2)} mg/L
          </div>
        </div>
      </div>
    </>
  );
};
